// Posts `ls.login` to the postMessage bridge content script so the extension
// can revoke its Bearer + clear `pairedAccount` iff the cached identity differs
// from the freshly-signed-in `userId`. Symmetrical with `useSignOut` posting
// `ls.logout` from UserCardDropdown. Shared by LoginPage (US-004) and SignUpPage
// (US-001) — the message shape, target and origin cross content-script worlds
// and must stay byte-for-byte identical. Wrapped in a try/catch since sandboxed
// iframes and private modes can reject postMessage.
export function notifyExtensionLogin(userId: string): void {
  try {
    window.postMessage({ type: 'ls.login', userId }, location.origin);
  } catch {
    /* sandboxed iframes / private mode — fine to swallow */
  }
}
